export default __webpack_public_path__ + "static/media/Speed Queen@3x.3038dd14.png";